import * as React from "react";
import { connect } from "react-redux";
import Iframe from 'react-iframe';
import { withRouter } from 'react-router';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import Cookies from "cookies-js";
import { getDomain } from "../../helpers/Tools";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";
import * as queryString from 'query-string';


class GuestCancelVisit extends React.Component {
    constructor(props) {
        super(props);
        this.serverData = this.props.serverData;
        this.state = {
            localization: 'english',
            localizationLabel: 'Ver en Español'
        };
        this.onLocalizationChangeClick = this.onLocalizationChangeClick.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Visit.GuestCancel.ComponentDidMount", new Date(), Tools.getURLPath());
    }
 
    onLocalizationChangeClick(e) {
        var myDomain = getDomain();
        var localization = '';
        if (Cookies.get('BSWLOCAL'))
            localization = Cookies.get('BSWLOCAL');
        if (localization && localization.length > 0) {
            if (localization === 'espanol') {
                Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
                //localizationlabel = "Ver en Español";
                this.setState({ localizationlabel: "Ver en Español" });
            }
            else {
                Cookies.set('BSWLOCAL', 'espanol', { expires: Infinity, path: '/', domain: myDomain });
                //localizationlabel = "View in English";
                this.setState({ localizationlabel: "View In English" });
            }

        }
        else {
            Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
            //localizationlabel = "View in English";
            this.setState({ localizationlabel: "Ver en Español" });
        }
        Cookies.set('BSWLOCAL', '', { expires: Infinity, path: '/', domain: myDomain });
    }

    render() {
        const searchParams = this.props.location.search ? queryString.parse(this.props.location.search) : null;                                 
        var mode = `/Visits/GuestCancel?csn=${searchParams && searchParams.csn ? searchParams.csn : ""}`;
        var preurl = this.props.serverData.myChartDataTileUrl.replace('/inside.asp?mode=', '');
        var url = `${preurl}${mode}`;
        const iframeResizerOptions = { checkOrigin: false, minHeight: 400, scrolling: true, heightCalculationMethod: 'bodyScroll' };
        const iframeResizerStyle = { width: '100%' };
        var localization = '';
        if (typeof window !== "undefined") {
            if (Cookies.get('BSWLOCAL'))
                localization = Cookies.get('BSWLOCAL');
        }
        if (localization && localization.length > 0)
            url += "?lang=" + localization;        

        return <MyChartContainer
            id={"mychartguestcancelvisit"}
            title="cancel appointment"
            iframeResizerOptions={iframeResizerOptions}
            src={url}
            style={iframeResizerStyle}
            ignoreChanges
            myChartNotRequired
            showLanguageLink={false}
        />;
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData
    };
};

const Tile = connect(
    mapStateToProps
)(GuestCancelVisit);

export default withRouter(Tile);